import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import type { FC, ReactElement } from 'react';

import getTheme from 'assets/themes/theme';

interface AppThemeProps {
  children: ReactElement[];
}

const AppTheme: FC<AppThemeProps> = ({ children }): ReactElement => (
  <ThemeProvider theme={getTheme()}>
    <StyledEngineProvider injectFirst>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      {children}
    </StyledEngineProvider>
  </ThemeProvider>
);

export default AppTheme;
